import { request } from '@/shared/api';
export function fetchTranscriptions(status = 'all') {
    return request(`/api/v1/transcriptions?status=${status}&limit=100`);
}
